"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var datapoints_1 = require("../datapoints");
var owa_analytics_1 = require("owa-analytics");
function searchCache(searchQuery, numberOfResults, recipientsToExclude, mailboxTypesToExclude) {
    var resultList = [];
    var i = 0;
    searchQuery = searchQuery.toLowerCase();
    while (resultList.length < numberOfResults &&
        (store_1.default.recipientCache && i < store_1.default.recipientCache.length)) {
        var email = store_1.default.recipientCache[i].EmailAddress;
        if ((email.EmailAddress && email.EmailAddress.toLowerCase().indexOf(searchQuery) == 0) ||
            (email.Name && email.Name.toLowerCase().indexOf(searchQuery) == 0)) {
            var skipRecipient = false;
            // Skip recipient if it's found in recipientsToExclude list
            if (recipientsToExclude && isDuplicated(email, recipientsToExclude)) {
                skipRecipient = true;
            }
            // Skip recipient if its mailbox type is in mailboxTypesToExclude
            if (mailboxTypesToExclude && mailboxTypesToExclude.indexOf(email.MailboxType) >= 0) {
                skipRecipient = true;
            }
            if (!skipRecipient) {
                resultList.push(store_1.default.recipientCache[i]);
            }
        }
        i++;
    }
    owa_analytics_1.logUsage(datapoints_1.default.RecipientCacheHitIndex.datapoint.name, datapoints_1.default.RecipientCacheHitIndex.datapoint.customData(i));
    return resultList;
}
exports.default = searchCache;
function isDuplicated(email, recipientsToCheck) {
    for (var j = 0; j < recipientsToCheck.length; j++) {
        if (email.EmailAddress == recipientsToCheck[j].EmailAddress.EmailAddress) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=searchCache.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-cache/lib/selectors/searchCache.js
// module id = 2638
// module chunks = 2 3 4 15 45 63 68